/**
$(function() {
    var topBtn = $('.btn_area');
    topBtn.hide();
    //スクロールが100に達したらボタン表示
    $(window).bind("scroll", function() {
    scrollHeight = $(document).height();
    scrollPosition = $(window).height() + $(window).scrollTop();
    if ( (scrollHeight - scrollPosition) / scrollHeight <= 0.125) {
        //スクロールの位置が下部5%の範囲に来た場合
        topBtn.fadeOut();
    } else {
        //それ以外のスクロールの位置の場合
        topBtn.fadeIn();
    }
});
});
**/


/** クーポンボタンクリックしたらモーダル **/
$(function() {
    var showFlag = false;
    var topBtn = $('.btn2');    
    topBtn.css('left', '-100px');
    var showFlag = false;
    //スクロールが100に達したらボタン表示
    $(window).scroll(function () {
        if ($(this).scrollTop() > 500) {
            if (showFlag == false) {
                showFlag = true;
                topBtn.stop().animate({'left' : '0px'}, 300); 
            }
        } 
        // else {
        //     if (showFlag) {
        //         showFlag = false;
        //         topBtn.stop().animate({'left' : '-100px'}, 200); 
        //     }
        // }
    });

    function popupImage() {
        var popup = document.getElementById('js-popup');
        if(!popup) return;
      
        var blackBg = document.getElementById('js-black-bg');
        var closeBtn = document.getElementById('js-close-btn');
        var showBtn = document.getElementById('js-show-popup');
      
        closePopUp(blackBg);
        closePopUp(closeBtn);
        closePopUp(showBtn);
        function closePopUp(elem) {
          if(!elem) return;
          elem.addEventListener('click', function() {
            popup.classList.toggle('is-show');
          });
        }
      }
      popupImage();

});




/** スクロールしたらモーダル **/
window.onload = function() {
    var popup = document.getElementById('js-popup');
    if(!popup) return;
    popup.classList.add('is-show');
  
    var blackBg = document.getElementById('js-black-bg');
    var closeBtn = document.getElementById('js-close-btn');
  
    closePopUp(blackBg);
    closePopUp(closeBtn);
  
    function closePopUp(elem) {
      if(!elem) return;
      elem.addEventListener('click', function() {
        popup.classList.remove('is-show');
      })
    }
  }


/*** クーポンコードをコピー ***/
document.querySelector('#copy_btn').addEventListener("click", () => {
  const element = document.querySelector('#targetID'),
    selection = window.getSelection(),
    range = document.createRange();
  range.selectNodeContents(element);
  selection.removeAllRanges();
  selection.addRange(range);
  //console.log('選択された文字列: ', selection.toString());
  const succeeded = document.execCommand('copy');
  if (succeeded) {
      alert('クーポンコードをコピーしました。');
  } else {
      alert('コピーが失敗しました!');
  }
  selection.removeAllRanges();

});




